(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lookbook"] && !Shopify.designMode) return;
  try {
     
  class luminLookBook extends HTMLElement {
    constructor () {
      super()

      this.injectVendorScripts()
      this.querySelectorAll('.lumin-lookbook-point-list-item').forEach((elem) => {
        this.handleTooltip(elem)
      })
    } 
    
    async injectVendorScripts () {
      if (!window.FloatingUICore) {
        const script = document.createElement('script')
        script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/core@1.6.0')
        document.head.appendChild(script) 
      }
      if (!window.FloatingUIDOM) {
        await new Promise(r => setTimeout(r, 500))

        const script = document.createElement('script')
        script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/dom@1.6.1')
        document.head.appendChild(script)
      }
    }

    handleTooltip(elem) {
      const btn = elem.querySelector('button')
      const tooltip = elem.querySelector('.lumin-tooltip')

      function update() {
        window.FloatingUIDOM.computePosition(btn, tooltip, {
          middleware: [
            window.FloatingUIDOM.offset(0),
            window.FloatingUIDOM.autoPlacement()
          ],
        }).then(({x, y}) => {
          Object.assign(tooltip.style, {
            left: `${x}px`,
            top: `${y}px`,
          })
        })
      }

      function showTooltip() {
        tooltip.classList.add('show')
        update()
      }
      
      function hideTooltip() {
        setTimeout(() => {
          tooltip.classList.remove('show')
          tooltip.classList.add('hiding')
          setTimeout(() => {
            tooltip.classList.remove('hiding')
          }, 200)
        }, 100)
      }
      
      if (window.matchMedia("(pointer: coarse)").matches) {
        [
          ['mouseenter', showTooltip],
          ['mouseleave', hideTooltip],
          ['focus', showTooltip],
          ['blur', hideTooltip],
        ].forEach(([event, listener]) => {
          btn.addEventListener(event, listener)
        })
      } else {
        [
          ['focus', showTooltip],
          ['blur', hideTooltip],
        ].forEach(([event, listener]) => {
          btn.addEventListener(event, listener)
        })
      }
    }
  }
  customElements.define('lumin-lookbook', luminLookBook)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-video-new"] && !Shopify.designMode) return;
  try {
    
class KsShoppableVideos extends HTMLElement {
  constructor () {
    super()
/*
    if (!document.querySelector('#swiper-stylesheet')) {
      const stylesheet = document.createElement('link')
      stylesheet.setAttribute('href', 'https://cdn.jsdelivr.net/npm/swiper@11.1.4/swiper-bundle.min.css')
      stylesheet.setAttribute('rel', 'stylesheet')
      stylesheet.setAttribute('id', 'swiper-stylesheet')
      stylesheet.setAttribute('integrity', 'sha256-5nkrwjVsiNfKz3NR1k2h5+qt5pS5SF2u9/TIT1hElow=')
      stylesheet.setAttribute('crossorigin', 'anonymous')
      document.head.appendChild(stylesheet)
    }

    if (!document.querySelector('#swiper-script')) {
      const script = document.createElement('script')
      script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/swiper@11.1.4/swiper-bundle.min.js')
      script.setAttribute('id', 'swiper-script')
      script.setAttribute('integrity', 'sha256-rCACDWCp/VzIh0rsB+ipQCM9XBvO8HNe0fNSOa4sys0=')
      script.setAttribute('crossorigin', 'anonymous')
      document.head.appendChild(script)
    }
*/
    setTimeout(() => {
      const slider = new window.Swiper(this.querySelector('.swiper'), this.splideOptions())

      slider.on('slideChange', () => {
        this.querySelector('.swiper').classList.add('swiper-is-changing')
        this.onSlideChange()
      })

      slider.on('slideChangeTransitionEnd', () => {
        this.querySelector('.swiper').classList.remove('swiper-is-changing')
      })
    }, 500)
    
    this.querySelectorAll('.lumin-shoppable-videos-btn-play').forEach(btn => {
      btn.addEventListener('click', () => {
        const video = btn.closest('.lumin-shoppable-videos-video-wrapper').querySelector('video')
        this.onVideoPlay(video)
      })
    })

    this.querySelectorAll('video').forEach(video => {
      video.addEventListener('click', () => {
        this.onVideoPlay(video)
      })
    })

    const lazyVideosObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.play()
        }
      })
    }, { rootMargin: '0px 0px 300px 0px' })
    
    this.querySelectorAll('video[data-autoplay="true"]').forEach((el) => {
      lazyVideosObserver.observe(el)
    })
  }

  splideOptions () {
    const partialSlidesMobile = this.dataset.partialSlidesMobile === 'true' ? 1.2 : 1

    /** @type {SwiperOptions} */
    const options = {
      rewind: true,
      speed: Number(this.dataset.sliderSpeed),
      breakpoints: {
        0: { slidesPerView: Number(this.dataset.breakpointXs) * partialSlidesMobile },
        576: { slidesPerView: Number(this.dataset.breakpointSm) },
        768: { slidesPerView: Number(this.dataset.breakpointMd) },
        992: { slidesPerView: Number(this.dataset.breakpointLg) },
        1200: { slidesPerView: Number(this.dataset.breakpointXl) },
        1400: { slidesPerView: Number(this.dataset.breakpointXxl) }
      },
      navigation: {
        enabled: this.dataset.sliderNav === 'true',
        nextEl: this.querySelector('.swiper-button-next'),
        prevEl: this.querySelector('.swiper-button-prev')
      },
      pagination: {
        enabled: this.dataset.sliderPagination === 'true',
        type: this.dataset.sliderPaginationType,
        el: '.swiper-pagination',
        dynamicBullets: true,
        dynamicMainBullets: 2,
        renderFraction: function (currentClass, totalClass) {
          return `<span class="${currentClass}"></span>/<span class="${totalClass}"></span>`
        }
      },
      scrollbar: {
        enabled: this.dataset.sliderScrollbar === 'true',
        el: this.querySelector('.swiper-scrollbar'),
        draggable: true
        // hide: true
      },
      autoplay: this.dataset.sliderAutoplay !== '0'
        ? { delay: Number(this.dataset.sliderAutoplay) * 1000 }
        : undefined,
      watchSlidesProgress: true, 
      mousewheel: {
        enabled: true,
        forceToAxis: true
      },
    }
    return options
  }

  onSlideChange () {
    this.querySelectorAll('.lumin-shoppable-videos-card').forEach(elem => {
      elem.setAttribute('data-is-playing', 'false')
      elem.querySelector('video')?.pause()
    })
  }

  onVideoPlay (video) {
    const card = video.closest('.lumin-shoppable-videos-card')

    this.querySelectorAll('.lumin-shoppable-videos-card').forEach(elem => {
      if (elem.dataset.index !== card.dataset.index) {
        elem.setAttribute('data-is-playing', 'false')
        elem.querySelector('video')?.pause()
      }
    })
    
    if (card.dataset.isPlaying === 'true') {
      card.setAttribute('data-is-playing', 'false')
      video.pause()
    } else {
      card.setAttribute('data-is-playing', 'true')
      video.muted = false
      video.play()
    }
  }
}
customElements.define('lumin-shoppable-videos', KsShoppableVideos)


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sl-hero-banner"] && !Shopify.designMode) return;
  try {
    
class SlHeroCarousel {
  constructor(root) {
    this.root = root;
    this.track = root.querySelector('[data-hero-track]');
    this.slides = Array.from(root.querySelectorAll('[data-hero-slide]'));
    this.dots = Array.from(root.querySelectorAll('[data-hero-dot]'));
    // 🔴 LAS TARJETAS VIVEN FUERA DEL CARRUSEL, asi que hay que subir a la seccion
    //    para encontrarlas: `root` es solo el visor. Estan fuera a proposito —el
    //    carril tiene `overflow-x: auto` y recortaria cualquier cosa que cuelgue de
    //    una diapositiva—.
    this.seccion = root.closest('.sl-hero');
    this.tira = this.seccion ? this.seccion.querySelector('[data-hero-zapas]') : null;
    this.zapas = this.tira ? Array.from(this.tira.querySelectorAll('[data-hero-zapa]')) : [];
    this.index = 0;
    this.timer = null;
    if (!this.track || this.slides.length < 2) return;

    this.slides.forEach((s, i) => { s.dataset.slLogico = i; });
    this.actual = this.slides[0];
    this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.interval = parseInt(root.dataset.interval, 10) || 6000;
    // 🔴 EN EL EDITOR NO GIRA SOLO. Auditoria del 8-sep-2026: mientras editabas el
    // banner, el carrusel seguia pasando diapositivas y te sacaba de la que
    // estabas tocando.
    this.enEditor = !!(window.Shopify && window.Shopify.designMode);
    this.wantsAutoplay = root.dataset.autoplay === 'true' && !this.reduced && !this.enEditor;

    // Sin autoplay no hay cuenta atras que enseñar: la barra sobra.
    if (this.tira && !this.wantsAutoplay) this.tira.classList.add('sl-hero__zapas--sin-tiempo');

    this.bind();
    this.observe();
    if (this.wantsAutoplay) this.start();
  }

  bind() {
    const prev = this.root.querySelector('[data-hero-prev]');
    const next = this.root.querySelector('[data-hero-next]');
    this.prevBtn = prev;
    this.nextBtn = next;
    if (prev) prev.addEventListener('click', () => { this.stop(); this.paso(-1); });
    if (next) next.addEventListener('click', () => { this.stop(); this.paso(1); });
    this.dots.forEach((d) => d.addEventListener('click', () => {
      this.stop();
      this.irA(parseInt(d.dataset.go, 10));
    }));
    this.root.addEventListener('pointerenter', () => this.stop());
    this.root.addEventListener('pointerleave', () => { if (this.wantsAutoplay) this.start(); });
    this.root.addEventListener('focusin', () => this.stop());

    // 🔴 EL RATON SOBRE UNA TARJETA SALTA A SU BANNER (Jorge, 14-sep-2026). Tres
    //    decisiones tomadas a sabiendas:
    //    · Solo con puntero FINO. En tactil no existe «pasar por encima»: el dedo
    //      que toca ya viene a pulsar, y cambiarle el banner debajo le robaria el
    //      clic al producto.
    //    · El FOCO no salta. La tarjeta es un enlace a la ficha, no un boton de
    //      carrusel: mover el banner al tabular seria un efecto secundario que
    //      nadie ha pedido. Para ir de banner en banner con teclado estan las
    //      flechas.
    //    · La tira no es `this.root`, asi que la pausa del autoplay que ya existia
    //      NO la cubria: hay que pausarla aqui o la cuenta seguiria corriendo
    //      mientras miras una zapatilla.
    this.zapas.forEach((z) => {
      z.addEventListener('pointerenter', (e) => {
        if (e.pointerType === 'touch') return;
        this.stop();
        this.irA(parseInt(z.dataset.go, 10));
      });
    });
    if (this.tira) {
      this.tira.addEventListener('pointerleave', () => { if (this.wantsAutoplay) this.start(); });
      this.tira.addEventListener('focusin', () => this.stop());
      this.tira.addEventListener('focusout', (e) => {
        // saltar entre tarjetas no es salir de la tira
        if (this.tira.contains(e.relatedTarget)) return;
        if (this.wantsAutoplay) this.start();
      });
    }
    this.track.addEventListener('pointerdown', () => { this.stop(); this.cortar(); }, { passive: true });
    // 🔴 EL CARRIL SE RECONCILIA CADA VEZ QUE SE QUEDA QUIETO. Revision del
    // 7-sep-2026, reproducido: si el usuario toca el carril durante los primeros
    // ~100ms de una transicion —en movil basta con apoyar el dedo para hacer
    // scroll VERTICAL de la pagina sobre el banner—, cortar() devolvia el iman,
    // el navegador reencajaba en la diapositiva de PARTIDA, y el punto se
    // quedaba marcando la de destino PARA SIEMPRE. Medido: descuadrado todavia
    // 2,5s despues. El observador no lo salvaba porque la de partida baja de 1.0
    // a 0.7 y vuelve a subir sin CRUZAR nunca el 0.55, asi que no dispara.
    // Escuchando el scroll con un respiro cubre esto y ademas cualquier arrastre
    // con el dedo que acabe a medio camino.
    this.track.addEventListener('scroll', () => {
      clearTimeout(this.reposo);
      this.reposo = setTimeout(() => { if (!this.raf) this.sincronizar(); }, 140);
    }, { passive: true });
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) this.stop();
      else if (this.wantsAutoplay) this.start();
    });
  }

  observe() {
    this.io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (this.enMarcha) return;      // movimiento nuestro: el indice ya esta puesto
        if (e.isIntersecting && e.intersectionRatio > 0.55) {
          this.actual = e.target;      // arrastre con el dedo: manda lo que se ve
          this.index = parseInt(e.target.dataset.slLogico, 10);
          this.paint();
        }
      });
    }, { root: this.track, threshold: [0.55] });
    this.slides.forEach((s) => this.io.observe(s));
  }

  // 🔴 PARA REINICIAR UNA ANIMACION CSS NO BASTA CON QUITAR Y PONER LA CLASE EN LA
  //    MISMA VUELTA: el navegador une las dos escrituras y no ve ningun cambio. Hay
  //    que forzar un reflow leyendo una medida en medio.
  reiniciarTiempo() {
    if (!this.zapas.length) return;
    const activa = this.zapas.find((z) => z.classList.contains('is-active'));
    if (!activa) return;
    const barra = activa.querySelector('.sl-hero__zapa-tiempo');
    if (!barra) return;
    barra.style.animation = 'none';
    void barra.offsetWidth;
    barra.style.animation = '';
  }

  paint() {
    this.zapas.forEach((z) => {
      const on = parseInt(z.dataset.go, 10) === this.index;
      z.classList.toggle('is-active', on);
      if (on) z.setAttribute('aria-current', 'true');
      else z.removeAttribute('aria-current');
    });
    this.reiniciarTiempo();
    // Ninguna flecha se apaga: el carrusel es circular, las dos llevan siempre
    // a algun sitio.
    this.dots.forEach((d, i) => {
      const on = i === this.index;
      d.classList.toggle('is-active', on);
      if (on) d.setAttribute('aria-current', 'true');
      else d.removeAttribute('aria-current');
    });
  }

  // 🔴 LA VUELTA SE DESLIZA, Y HACIA EL LADO CORRECTO. Jorge, 7-sep-2026:
  // «quiero que haga la transicion tambien».
  //
  // El problema de fondo: un carrusel de scroll no puede ir «de la ultima a la
  // primera» animando, porque la primera esta al principio del carril — animar
  // hasta ella es recorrer los 2880px hacia atras, que es exactamente el fallo
  // que Jorge reporto («cuando pulsas hacia atras va hacia delante»).
  //
  // La solucion no es animar mas rapido ni saltar: es MOVER LA DIAPOSITIVA DE
  // SITIO antes de animar. Estando en la ultima y pulsando «siguiente», cojo la
  // primera del DOM y la pego al final; el carril se ha acortado por la
  // izquierda, asi que descuento un ancho al scroll en el mismo fotograma para
  // que visualmente no se mueva nada. Ahora la primera esta a mi derecha, y el
  // destino vuelve a ser la contigua: un paso normal, deslizado, hacia delante.
  //
  // Consecuencia: TODOS los movimientos de flecha son de una diapositiva. No
  // hay caso especial, no hay salto, y la direccion nunca puede leerse al reves.
  // El precio es que el orden del DOM deja de coincidir con el orden logico —de
  // ahi que el indice y los puntos vayan por data-sl-logico y no por posicion.
  // 🔴 LOS CLICS SE ENCOLAN Y EL CARRIL SOLO SE REORDENA EN REPOSO.
  // Jorge, 7-sep-2026: «si le doy muy rapido a las flechas es como que se raya».
  // Dos causas, las dos medidas:
  //  1. La vuelta compensa la reordenacion con scrollLeft -= ancho, y eso solo
  //     cabe si queda un ancho por delante. En reposo siempre cabe; a media
  //     animacion no —con dos diapositivas la cuenta se iba por debajo de cero,
  //     el navegador RECORTABA la compensacion, y ese recorte era el tiron—.
  //  2. Encadenando pasos se perdia un fotograma en cada empalme: la animacion
  //     terminaba, devolvia el control, y el tramo siguiente no empezaba a
  //     pintar hasta el fotograma de despues. Un parpadeo por paso.
  // Solucion: un unico bucle que nunca suelta el mando. Cuando un tramo acaba,
  // el siguiente se prepara y se pinta DENTRO DEL MISMO FOTOGRAMA, arrastrando
  // el tiempo sobrante para que no se pierda ni un milisegundo.
  paso(dir) {
    // 🔴 AL ARRANCAR UNA CADENA, MANDA LA PANTALLA. Dentro de una cadena hay que
    // fiarse de this.actual (el carril esta a medio camino y no se puede leer),
    // pero si no hay nada en marcha el carril esta parado en un hueco exacto y
    // lo que se ve es mas fiable que el estado. Sin esto, tras un corte a media
    // transicion el ancla apuntaba a una diapositiva que nunca llego, y la
    // "alineacion previa" de prepararTramo dejaba de ser un no-op para
    // convertirse en un salto de un ancho entero: un solo clic avanzaba dos, la
    // primera mitad de un tiron seco.
    if (!this.raf) this.sincronizar();
    if (this.raf) this.encadenado = true;      // ha llegado con algo en marcha
    this.cola = Math.max(-6, Math.min(6, (this.cola || 0) + dir));
    if (!this.raf) this.arrancar(performance.now());
  }

  arrancar(t0) {
    if (!this.prepararTramo(t0)) { this.acabar(); return; }
    this.raf = requestAnimationFrame((t) => this.bucle(t));
  }

  // Reordena (si toca) y deja listo el tramo siguiente. Devuelve false si no
  // queda nada que hacer. SIEMPRE se llama con el carril parado en un hueco
  // exacto, que es la unica situacion en la que la compensacion cabe entera.
  prepararTramo(t0) {
    if (!this.cola) return false;
    const dir = this.cola > 0 ? 1 : -1;
    this.cola -= dir;

    let carril = Array.from(this.track.querySelectorAll('[data-hero-slide]'));
    const n = carril.length;
    const ancho = carril[0].offsetWidth;
    if (!ancho) return false;
    // El ancla es la DIAPOSITIVA, no el scrollLeft: un numero a medio camino
    // redondea al hueco equivocado. El scroll solo es la red por si se pierde.
    const desde = (this.actual && carril.indexOf(this.actual) >= 0)
      ? this.actual
      : carril[Math.max(0, Math.min(n - 1, Math.round(this.track.scrollLeft / ancho)))];
    const aqui = carril.indexOf(desde);
    const cero0 = carril[0].offsetLeft;

    this.track.style.scrollSnapType = 'none';
    // Alinear antes de mover ningun nodo. No se ve —ya estamos ahi— y garantiza
    // que la compensacion de abajo no se salga de rango.
    this.track.scrollLeft = desde.offsetLeft - cero0;

    if (dir > 0 && aqui === n - 1) {
      this.track.appendChild(carril[0]);
      this.track.scrollLeft -= ancho;
    } else if (dir < 0 && aqui === 0) {
      this.track.insertBefore(carril[n - 1], carril[0]);
      this.track.scrollLeft += ancho;
    }

    carril = Array.from(this.track.querySelectorAll('[data-hero-slide]'));
    const destino = carril[carril.indexOf(desde) + dir];
    if (!destino) return false;

    this.actual = destino;
    this.index = parseInt(destino.dataset.slLogico, 10);
    this.enMarcha = true;          // el observador no toca el indice mientras dura
    this.paint();

    const x2 = destino.offsetLeft - carril[0].offsetLeft;
    if (this.reduced) { this.track.scrollLeft = x2; this.cola = 0; return false; }

    // Un paso suelto frena al llegar. Los tramos intermedios de una cadena van a
    // velocidad constante y solo frena el ultimo, para que seis clics seguidos
    // se lean como un desplazamiento largo y no como seis tirones pegados. La
    // frenada final dura mas para entrar a la misma velocidad que traia.
    const intermedio = this.cola !== 0;
    this.tramo = {
      x1: this.track.scrollLeft, x2, t0,
      ms: intermedio ? 200 : (this.encadenado ? 620 : 460),
      recto: intermedio
    };
    return true;
  }

  bucle(t) {
    // Un tramo puede haber acabado hace rato si el navegador se salto
    // fotogramas: se consumen todos los vencidos arrastrando el tiempo sobrante.
    while (this.tramo && t - this.tramo.t0 >= this.tramo.ms) {
      const fin = this.tramo.t0 + this.tramo.ms;
      this.track.scrollLeft = this.tramo.x2;
      this.tramo = null;
      if (this.cola) this.prepararTramo(fin);
    }
    if (!this.tramo) { this.raf = 0; this.acabar(); return; }
    const s = this.tramo;
    const p = Math.max(0, Math.min(1, (t - s.t0) / s.ms));
    this.track.scrollLeft = s.x1 + (s.x2 - s.x1) * (s.recto ? p : 1 - Math.pow(1 - p, 3));
    this.raf = requestAnimationFrame((tt) => this.bucle(tt));
  }

  // Los puntos son un destino explicito: el usuario ha señalado a cual quiere ir,
  // asi que aqui si vale recorrer el carril —no hay direccion que malinterpretar—.
  irA(logico) {
    const carril = Array.from(this.track.querySelectorAll('[data-hero-slide]'));
    const destino = carril.find((s) => parseInt(s.dataset.slLogico, 10) === logico);
    if (!destino || destino === this.actual) return;
    cancelAnimationFrame(this.raf);
    this.cola = 0;
    this.encadenado = false;
    this.actual = destino;
    this.index = logico;
    this.enMarcha = true;
    this.paint();
    const x2 = destino.offsetLeft - carril[0].offsetLeft;
    if (this.reduced) { this.track.scrollLeft = x2; this.acabar(); return; }
    this.track.style.scrollSnapType = 'none';
    this.tramo = { x1: this.track.scrollLeft, x2, t0: performance.now(), ms: 460, recto: false };
    this.raf = requestAnimationFrame((t) => this.bucle(t));
  }

  // El dedo manda: si el usuario empieza a arrastrar, nos apartamos y tiramos la
  // cola —lo que quiera hacer ahora pesa mas que lo que pidio hace medio segundo—.
  cortar() {
    cancelAnimationFrame(this.raf);
    this.raf = 0;
    this.tramo = null;
    this.cola = 0;
    this.encadenado = false;
    this.enMarcha = false;
    this.track.style.scrollSnapType = '';
  }

  acabar() {
    this.raf = 0;
    this.tramo = null;
    this.cola = 0;
    this.encadenado = false;
    this.enMarcha = false;
    this.track.style.scrollSnapType = '';
    this.sincronizar();
  }

  // 🔴 AL SOLTAR, LA PANTALLA MANDA. El observador solo se despierta al cruzar
  // el 55%: si la diapositiva ya llevaba rato entera en pantalla, ese cruce no
  // vuelve a pasar y un desajuste no se corregiria solo. Aqui ya no hay nada en
  // marcha, asi que leer el carril es seguro: lo que se ve es la verdad.
  sincronizar() {
    const carril = Array.from(this.track.querySelectorAll('[data-hero-slide]'));
    if (!carril.length) return;
    const ancho = carril[0].offsetWidth;
    if (!ancho) return;
    const i = Math.max(0, Math.min(carril.length - 1, Math.round(this.track.scrollLeft / ancho)));
    if (carril[i] === this.actual) return;
    this.actual = carril[i];
    this.index = parseInt(carril[i].dataset.slLogico, 10);
    this.paint();
  }

  start() {
    this.stop();
    this.timer = setInterval(() => this.paso(1), this.interval);
    // 🔴 EL RELOJ Y LA BARRA ARRANCAN JUNTOS. `setInterval` empieza de cero cada
    //    vez que se reanuda; si la barra se quedase donde la dejo la pausa,
    //    llegaria al final antes de tiempo y se quedaria llena esperando.
    this.reiniciarTiempo();
  }

  stop() {
    if (this.timer) clearInterval(this.timer);
    this.timer = null;
  }
}

// 🔴 EL HERO SE APAGA CUANDO DEJA DE VERSE. Auditoria del 8-sep-2026,
// reproducido: con la pagina bajada, al tabular desde la cabecera se pasaba por
// el CTA del banner, las dos flechas y los puntos SIN VER NADA — el hero sigue
// dentro de la ventana porque esta clavado, asi que el navegador no desplaza
// para enseñarlo, pero las secciones que suben lo tapan. Cinco paradas ciegas, y
// una es un enlace: pulsar Enter te llevaba a otra pagina sin saber a donde.
// Antes de clavarlo no pasaba, porque el hero se iba fuera de la ventana y el
// navegador lo traia a la vista al enfocarlo.
// `inert` lo saca del tabulador y del arbol de accesibilidad de una vez, sin
// tocar el CSS ni el orden visual.
// 🔴 EL EDITOR DE TEMAS, ATENDIDO. Auditoria del 8-sep-2026:
//  · seleccionar la seccion Banner no la traia a la vista, porque va clavada y
//    el editor no encuentra a donde desplazar;
//  · seleccionar una diapositiva no saltaba a ella, asi que editabas a ciegas.
if (window.Shopify && window.Shopify.designMode) {
  document.addEventListener('shopify:section:select', function (e) {
    if (!e.target.querySelector || !e.target.querySelector('.sl-hero')) return;
    var env = e.target.closest('#MainContent > *') || e.target;
    window.scrollTo({ top: Math.max(0, env.offsetTop - 120), behavior: 'smooth' });
  });
  document.addEventListener('shopify:block:select', function (e) {
    var slide = e.target.matches && e.target.matches('[data-hero-slide]')
      ? e.target
      : (e.target.closest ? e.target.closest('[data-hero-slide]') : null);
    if (!slide) return;
    var raiz = slide.closest('[data-hero-carousel]');
    if (!raiz || !raiz.slHero) return;
    raiz.slHero.stop();
    raiz.slHero.irA(parseInt(slide.dataset.slLogico, 10));
  });
}

// 🔴 EL APILADO SE COLOCA DESDE AQUI, Y LO TAPADO SE APAGA.
// Dos trabajos en uno:
//  1. Colocar. A cada seccion se le da su `top` y su `z-index`. El z-index sale
//     del ORDEN en el DOM para que el editor de temas pueda reordenar sin que
//     se rompa el apilado. El `top` es 0 si la seccion cabe en la ventana; si es
//     mas alta, se clava cuando su PIE llega al pie de la ventana (top negativo)
//     para que se pueda leer entera antes de quedarse fija.
//  2. Apagar. Una seccion clavada y tapada sigue siendo tabulable aunque no se
//     vea: el foco del teclado caeria dentro y no se veria el anillo. Es el
//     mismo fallo que la auditoria encontro con el hero, y ahora lo tendrian
//     todas. Se marcan `inert` en cuanto la siguiente las cubre del todo.
function slApilar() {
  const main = document.querySelector('#MainContent');
  // Solo con el ajuste «portada nueva»: sin el, este banner va solo, sin tocar
  // el resto de la pagina (asi esta en el tema en vivo desde el 1-oct-2026).
  if (!main || !main.querySelector('.sl-hero--portada')) return;

  // ── LA BARAJA DE COLECCIONES ────────────────────────────────────────────────
  // Jorge, 11-sep-2026, con adobe.com de referencia: cada coleccion (Back 2
  // School, New, Best Sellers) es una tarjeta y al bajar se revelan una detras
  // de otra. Medido en Adobe (movil): las tarjetas son sticky DENTRO DE UN
  // CONTENEDOR PROPIO, y es ese contenedor el que acota el sticky —al llegar a
  // la ultima se sueltan todas y siguen bajando con la pagina—. Aqui las
  // secciones son hermanas en #MainContent, asi que el contenedor se crea en el
  // navegador y entran en el las colecciones CONSECUTIVAS que siguen al banner.
  // En el editor de temas no se monta: el editor reordena secciones moviendo
  // nodos hermanos, y metidas en un envoltorio se descolocarian.
  if (!(window.Shopify && window.Shopify.designMode) && !main.querySelector(':scope > .sl-baraja')) {
    const hijos = Array.from(main.children).filter(
      (e) => !['SCRIPT', 'STYLE', 'LINK', 'NOSCRIPT', 'TEMPLATE'].includes(e.tagName)
    );
    const iBanner = hijos.findIndex((e) => e.querySelector && e.querySelector('.sl-hero'));
    // Delante de las colecciones puede ir una tira (la de confianza): entra en el
    // contenedor blanco pero NO es una tarjeta, no se clava ni se estrecha.
    let i = iBanner + 1;
    const delanteras = [];
    while (i < hijos.length && /sl_tira|sl_ticker/.test(hijos[i].id || '')) {
      delanteras.push(hijos[i]);
      i++;
    }
    const cartas = [];
    for (; i < hijos.length; i++) {
      if (/featured_collection/.test(hijos[i].id || '')) cartas.push(hijos[i]);
      else break;
    }
    if (cartas.length >= 2) {
      const baraja = document.createElement('div');
      baraja.className = 'sl-baraja';
      main.insertBefore(baraja, delanteras[0] || cartas[0]);
      delanteras.forEach((e) => baraja.appendChild(e));
      const n = cartas.length;
      cartas.forEach((c, i) => {
        c.classList.add('sl-carta');
        // Numeros medidos en Adobe con cinco tarjetas, repartidos para las que
        // haya: la mas vieja es la que mas sube y la que mas se estrecha; la
        // ultima nunca llega a enterrarse.
        c.style.setProperty('--sl-i', String(i));
        c.style.setProperty('--sl-off', (6 + 8 * i) + 'px');
        c.style.setProperty('--sl-encoge', ((n - 1 - i) * 14) + 'px');
        baraja.appendChild(c);
      });
    }
  }

  const secs = Array.from(main.children).filter(
    (e) => !['SCRIPT', 'STYLE', 'LINK', 'NOSCRIPT', 'TEMPLATE'].includes(e.tagName)
  );
  if (secs.length < 2) return;

  // El pie real de la cabecera fija: cambia con el idioma y con el ancho, asi que
  // se mide en vez de escribir un numero.
  const raiz = document.documentElement;
  let techoCache = 0;
  let canalon = document.getElementById('sl-canalon');
  if (!canalon) {
    canalon = document.createElement('div');
    canalon.id = 'sl-canalon';
    document.body.appendChild(canalon);
  }

  const techo = () => {
    const b = document.querySelector('.section-header');
    return b ? Math.max(0, Math.round(b.getBoundingClientRect().bottom)) : 0;
  };

  // ── UN SOLO TOPE PARA TODAS ─────────────────────────────────────────────
  // 🔴 MEDIDO EN LA REFERENCIA (emestudios.com, 9-sep-2026): sus secciones son
  // TODAS `sticky top:0`, sin escalon, sin radio y sin sombra. Cada una se clava
  // arriba y la siguiente la tapa ENTERA. No hay cantos acumulados.
  //
  // 🔴 Y LA ESCALERA AQUI ES FISICAMENTE IMPOSIBLE. Una seccion clavada no
  // vuelve a moverse, asi que su pie solo se ve si `tope + alto <= ventana`.
  // Medido a 1440x900: «Cada par lleva su chapa» mide 800 y «Best Sellers» 729,
  // con la cabecera en 97. Sus topes maximos son 100 y 171: por debajo del
  // escalon de las anteriores. Con escalera o se salen del apilado o se les
  // corta el pie para siempre. Con un unico tope = pie de la cabecera, entran
  // TODAS y no se corta ninguna (800 + 97 = 897 < 900).
  //
  // El efecto de carta lo dan el radio y la sombra de la que sube, no el escalon.
  // 🔴 SOLO SE ESCRIBE SI EL VALOR CAMBIA. `colocar()` la llama un ResizeObserver
  // puesto en cada seccion; si escribe `position`/`top` a ciegas, cambia la
  // maquetacion, el observer se vuelve a disparar y se entra en bucle: el hilo
  // de pintado se queda al 100% y la pestaña deja de responder (9-sep-2026, con
  // el navegador colgado en la portada: ni capturas ni navegacion).
  const poner = (el, prop, val) => { if (el.style[prop] !== val) el.style[prop] = val; };

  // 🔴 DONDE EMPIEZA EL NEGRO. Se busca la seccion de la chapa por su id, no por
  // un numero de orden: el editor de temas reordena secciones y un indice fijo se
  // rompe a la primera que Jorge mueva una. De ahi hacia abajo, todo va a sangre.
  const marcarBloques = () => {
    let corte = secs.findIndex((s) => /chapa/i.test(s.id || ''));
    if (corte < 1) corte = secs.length;            // sin chapa, no hay bloque negro
    secs.forEach((s, i) => {
      const banner = i === 0;
      const blanca = i > 0 && i < corte;
      s.classList.toggle('sl-banner', banner);
      s.classList.toggle('sl-blanca', blanca);
      s.classList.toggle('sl-blanca-primera', i === 1);
      s.classList.toggle('sl-blanca-ultima', i === corte - 1);
      s.classList.toggle('sl-oscura', i >= corte);
      s.classList.toggle('sl-oscura-primera', i === corte);
    });
    return corte;
  };

  const colocar = () => {
    const t = techo();
    techoCache = t;
    const vh = window.innerHeight;
    // Una tarjeta de la baraja que no quepa entera bajo la cabecera no se clava:
    // su pie no se veria nunca. Pasa en portatiles bajos; en movil caben.
    const baraja = main.querySelector(':scope > .sl-baraja');
    if (baraja) {
      // el mismo desfase que usa el `top` en el CSS: se lee, no se repite
      const extra = parseFloat(getComputedStyle(baraja).getPropertyValue('--sl-tope-extra')) || 38;
      baraja.querySelectorAll(':scope > .sl-carta').forEach((c) => {
        c.classList.toggle('sl-carta--suelta', c.getBoundingClientRect().height > vh - (t + extra));
      });
    }
    // 🔴 LAS TARJETAS DE LA BARAJA MIDEN LO MISMO. Al soltarse, el sticky empuja
    // cada tarjeta segun SU altura —cabe hasta el pie del contenedor—: con 694,
    // 711 y 707 px la del medio subia 21 y la primera 3, asi que la mas vieja
    // quedaba DEBAJO de la del medio y en escritorio solo asomaba un canto en vez
    // de dos (medido el 11-sep-2026). Igualadas, se sueltan a la vez.
    // Se mide el contenido y no la caja, porque la caja ya lleva el min-height:
    // asi el valor no cambia de una pasada a otra y el ResizeObserver no entra en
    // bucle. Por eso tambien el estrechado es con clip-path y no con margin.
    const tarjetas = Array.from(main.querySelectorAll(':scope > .sl-baraja > .sl-carta > .sl-tarjetas'));
    if (tarjetas.length > 1) {
      const natural = (el) => {
        const r = el.getBoundingClientRect();
        let fondo = r.top;
        for (const h of el.children) fondo = Math.max(fondo, h.getBoundingClientRect().bottom);
        return Math.ceil(fondo - r.top);
      };
      const alto = Math.max(...tarjetas.map(natural));
      tarjetas.forEach((el) => poner(el, 'minHeight', alto + 'px'));
    }
    const corte = marcarBloques();
    // El fondo del canalon necesita saber donde acaba la cabecera.
    if (raiz.style.getPropertyValue('--sl-techo') !== t + 'px') {
      raiz.style.setProperty('--sl-techo', t + 'px');
    }
    secs.forEach((s, i) => {
      // 🔴 EL ORDEN DE CAPAS NO ES EL DEL DOM. De abajo arriba: el banner (1), el
      // bloque negro (2) y el contenedor blanco (10+). El negro tiene que quedar
      // POR DEBAJO del contenedor para que por las muescas de sus esquinas de
      // abajo se vea negro y no el banner.
      poner(s, 'zIndex', String(i === 0 ? 1 : i < corte ? 10 + i : 2));
      const altoSec = s.getBoundingClientRect().height;
      // 🔴 EL BANNER SE QUEDA QUIETO Y EL BLANCO SE LO COME. Clavado arriba del
      // todo, el contenedor blanco sube por encima y lo va tapando: ese es el
      // efecto que pidio Jorge el 10-sep-2026. Antes pasaba de largo, y entre uno
      // y otro quedaba una franja del fondo negro.
      // Si el banner fuese mas alto que la ventana no se clava: su pie no se
      // veria nunca.
      if (i === 0) {
        if (altoSec > vh) { poner(s, 'position', 'relative'); poner(s, 'top', 'auto'); }
        else { poner(s, 'position', ''); poner(s, 'top', '0px'); }
        return;
      }
      // 🔴 EL CONTENEDOR BLANCO BAJA DE UNA PIEZA. Si cada una de sus cuatro
      // secciones se clavara, se verian deslizarse una sobre otra y dejaria de
      // leerse como un solo contenedor, que es justo lo que Jorge pidio el
      // 10-sep-2026. Bajan juntas; el bloque negro sube por encima de todas.
      if (i > 0 && i < corte) { poner(s, 'position', 'relative'); poner(s, 'top', 'auto'); return; }
      const alto = altoSec;
      // 🔴 UNA SECCION DE SOLO TITULAR NO ES UNA CARTA. «Nuestra Tienda» mide 49px
      // y «Ven a conocernos» 94: son encabezados del bloque que viene debajo. Con
      // el radio y la sombra de carta, cada una dibujaba su propio canto y se
      // veian DOS bordes a 48px con una franja blanca en medio, que se lee como
      // un escalon. Se quedan sin tratamiento de carta y sin clavar: forman una
      // sola pieza con la seccion siguiente.
      const menuda = alto < 120;
      s.classList.toggle('sl-no-carta', menuda);
      if (menuda) { poner(s, 'position', 'relative'); poner(s, 'top', 'auto'); return; }
      // 🔴 DEL NEGRO HACIA ABAJO ES WEB NORMAL. Jorge, 10-sep-2026: «a partir de
      // que salga lo negro, no haya solapamiento y sea web normal sin el sticky
      // stacked». Ademas esto arregla otra cosa que el mismo vio: con el negro
      // clavado, el contenedor blanco seguia subiendo y entre los dos se abria un
      // hueco por el que asomaba el banner —una raya marron justo debajo del
      // blanco—. Pegados y sin clavar, por las esquinas de abajo del contenedor
      // se ve el negro, que es lo que pidio.
      if (i >= corte) { poner(s, 'position', 'relative'); poner(s, 'top', 'auto'); return; }
      // Una seccion clavada ya no se mueve: si no cabe entera bajo la cabecera,
      // su pie no se veria NUNCA. Esas no se clavan, pasan de largo.
      if (alto > vh - t) {
        poner(s, 'position', 'relative');
        poner(s, 'top', 'auto');
        return;
      }
      poner(s, 'position', '');
      poner(s, 'top', t + 'px');
    });
  };

  let pedido = false;
  const revisar = () => {
    pedido = false;
    // 🔴 EL CANALON DE 16px SE TAPA EN CUANTO SE PASA EL BANNER. Al final de la
    // portada las cartas se despegan solas —`sticky` deja de sujetar cuando se
    // acaba su contenedor, y el pie va fuera de #MainContent— y suben por detras
    // de la cabecera: por el canalon asomaban trozos de foto y la palabra
    // «CHAPA» encima del ticker (medido a scroll 5440, 5600 y 5760). Arriba del
    // todo NO se tapa, porque ahi el banner tiene que sangrar hasta el borde.
    // 🔴 EL DISPARADOR YA NO PUEDE SER «el banner se ha ido de pantalla»: el
    // banner esta clavado arriba y no se va nunca. Se mira el contenedor blanco:
    // en cuanto su borde de arriba pasa por debajo de la cabecera, ya no hay
    // banner que ensenar por el canalon y este se tapa.
    const primera = secs[1] || secs[0];
    document.body.classList.toggle('sl-canalon', primera.getBoundingClientRect().top <= techoCache);
    for (let i = 0; i < secs.length - 1; i++) {
      const yo = secs[i].getBoundingClientRect().top;
      const siguiente = secs[i + 1].getBoundingClientRect().top;
      const cubierta = siguiente <= yo + 2;
      if (secs[i].inert !== cubierta) secs[i].inert = cubierta;
      // 🔴 SOLO LA DE ARRIBA DIBUJA CANTO. Todas se clavan en el mismo tope, asi
      // que sus sombras se apilan en el mismo pixel y se SUMAN: medido en el
      // canalon de 16px de la cabecera, el gris pasaba de 255 a 223 segun se
      // bajaba, como una mancha que crece. Las tapadas conservan solo la sombra
      // solida de 80px, que es la que sella los huecos entre secciones.
      secs[i].classList.toggle('sl-tapada', cubierta);
    }
  };
  const pedir = () => { if (!pedido) { pedido = true; requestAnimationFrame(revisar); } };

  colocar();
  revisar();
  window.addEventListener('scroll', pedir, { passive: true });
  window.addEventListener('resize', () => { colocar(); pedir(); }, { passive: true });
  // Las fotos que cargan tarde cambian la altura de su seccion.
  if ('ResizeObserver' in window) {
    const ro = new ResizeObserver(() => { colocar(); pedir(); });
    secs.forEach((s) => ro.observe(s));
  }
}

// 🔴 CUANTO MIDE LA TIRA DE ZAPATILLAS, PARA QUE EL TEXTO LA ESQUIVE.
// La tira va absoluta al pie del banner. Cuando cae en modo franja se planta
// justo donde acaba el bloque de texto, y su alto depende de en cuantas lineas
// parta el nombre del producto: 44, 58 o 78px medidos el 22-sep-2026. Escribir
// esos numeros a mano dura hasta que alguien cambie un titulo, asi que se miden.
// En modo esquina la tira no estorba y se publica 0.
function slHeroAireTira(hero) {
  const tira = hero.querySelector('.sl-hero__zapas');
  if (!tira) return;
  const anchoHero = hero.getBoundingClientRect().width;
  const rt = tira.getBoundingClientRect();
  const franja = Math.round(rt.width) >= Math.round(anchoHero) - 1;
  // 🔴 NO ES EL ALTO DE LA TIRA, ES LO QUE HAY QUE SUBIR. La tira tampoco se
  // apoya siempre a la misma distancia del canto: a 390 su pie queda a 38px del
  // borde y a 880 a 70px. Midiendo del borde de abajo del banner al TOPE de la
  // tira, las dos variables quedan dentro de un solo numero y el hueco sale
  // constante en todos los anchos.
  const val = (franja ? Math.ceil(hero.getBoundingClientRect().bottom - rt.top) : 0) + 'px';
  // 🔴 SOLO SE ESCRIBE SI CAMBIA: el ResizeObserver que llama aqui vigila la
  // propia tira, y escribir a ciegas lo vuelve a disparar en bucle.
  if (hero.style.getPropertyValue('--sl-zapas-alto') !== val) {
    hero.style.setProperty('--sl-zapas-alto', val);
  }
}

function slHeroInit() {
  document.querySelectorAll('[data-hero-carousel]').forEach((el) => {
    if (!el.slHero) el.slHero = new SlHeroCarousel(el);
  });
  document.querySelectorAll('.sl-hero').forEach((hero) => {
    slHeroAireTira(hero);
    if (hero.dataset.aireAtado) return;
    hero.dataset.aireAtado = '1';
    const recalcular = () => slHeroAireTira(hero);
    window.addEventListener('resize', recalcular, { passive: true });
    const tira = hero.querySelector('.sl-hero__zapas');
    if (tira && 'ResizeObserver' in window) new ResizeObserver(recalcular).observe(tira);
    // las miniaturas cargan tarde y pueden cambiar el alto de la tarjeta
    hero.querySelectorAll('.sl-hero__zapa-foto img').forEach((img) => {
      if (!img.complete) img.addEventListener('load', recalcular, { once: true });
    });
  });
  slApilar();
  slHeroTecho();
}

// 🔴 EL TECHO TAMBIEN SIN LA PORTADA NUEVA. El texto «arriba» en movil se coloca
// bajo la cabecera flotante con `--sl-techo`, que media slApilar. Sin la portada
// nueva slApilar no corre y quedaba el respaldo de 97px: en el tema en vivo la
// cabecera acaba en 102 (movil) y 117 (ordenador). Se mide igual, con la pagina
// arriba del todo, que es cuando el banner esta debajo de la cabecera.
function slHeroTecho() {
  if (document.querySelector('.sl-hero--portada')) return;
  if (window.slHeroTechoAtado) return;
  window.slHeroTechoAtado = true;
  const medir = () => {
    if (window.scrollY > 4) return;
    const b = document.querySelector('.section-header');
    if (!b) return;
    const t = Math.max(0, Math.round(b.getBoundingClientRect().bottom));
    const raiz = document.documentElement;
    if (raiz.style.getPropertyValue('--sl-techo') !== t + 'px') raiz.style.setProperty('--sl-techo', t + 'px');
  };
  medir();
  window.addEventListener('resize', medir, { passive: true });
  window.addEventListener('load', medir);
}

document.addEventListener('DOMContentLoaded', slHeroInit);
document.addEventListener('shopify:section:load', slHeroInit);
slHeroInit();

  } catch(e) { console.error(e); }
})();
})();
